import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PasoonVoiceIntro } from '../components/PasoonVoiceIntro';
import { IntroSection } from '../components/IntroSection';
import { AboutSection } from '../components/AboutSection';
import { CurrentIssue } from '../components/CurrentIssue';
import { PublishingCycle } from '../components/PublishingCycle';
import { ArchivePreview } from '../components/ArchivePreview';
import { SubscriptionSupport } from '../components/SubscriptionSupport';
import { Language } from '../App';
interface HomeProps {
  language: Language;
}
export function Home({
  language
}: HomeProps) {
  return <div data-id="element-536">
      <HeroSection language={language} data-id="element-537" />
      <PasoonVoiceIntro language={language} data-id="element-538" />
      <IntroSection language={language} data-id="element-539" />
      <AboutSection language={language} data-id="element-540" />
      <CurrentIssue language={language} data-id="element-541" />
      <PublishingCycle language={language} data-id="element-542" />
      <ArchivePreview language={language} data-id="element-543" />
      <SubscriptionSupport language={language} data-id="element-544" />
    </div>;
}